import { lazy } from 'react';

import { MenuItemConfig, ReactPageConfig, RestActionType } from '@intelliarts/ia-react-template';

import authConfig, { CONFIGURATION_MENU_GROUP } from '../../../config/authConfig';
import { CONFIGURATION_PAGE_LOCALE_PATH } from '../../Employee/locales';
import { changeReasonsActions, ChangeReasonsStore } from '../../Employee/store/changeReasonsStore';

export const ConfigurationRoutes = {
  default: 'configuration',
};

export const ConfigurationPageConfig: ReactPageConfig = {
  name: `${CONFIGURATION_PAGE_LOCALE_PATH}.pageConfig.name`,
  path: ConfigurationRoutes.default,
  allowedRoles: authConfig.roles.ALL,
  component: lazy(() => import('../components/ConfigurationPage')),
  storeDependencies: [
    { store: ChangeReasonsStore, onContainerInitAction: changeReasonsActions[RestActionType.GET] },
  ],
  menuItemConfig: new MenuItemConfig({
    icon: lazy(() => import('@mui/icons-material/Tune')),
    label: `${CONFIGURATION_PAGE_LOCALE_PATH}.pageConfig.label`,
    group: CONFIGURATION_MENU_GROUP,
    isCollapsibleGroup: true,
  }),
};
